import React, { useState } from 'react';
import axios from 'axios';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { toast } from 'sonner';
import { Mail, ArrowLeft, Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ForgotPassword = ({ onBack }) => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email || !/^\S+@\S+\.\S+$/.test(email)) return toast.error('Please enter a valid email');
    setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
      toast.success('If that email is registered, a reset link is on its way.');
    } catch {
      toast.error('Could not send reset email. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        <Card className="glass border-0 shadow-2xl">
          <CardHeader>
            <div className="flex justify-center mb-2">
              <div className="p-3 rounded-full bg-blue-100"><Mail className="h-6 w-6 text-blue-600" /></div>
            </div>
            <CardTitle className="text-2xl text-center">Forgot Password?</CardTitle>
            <CardDescription className="text-center">
              Enter your account email and we&apos;ll send you a reset link.
            </CardDescription>
          </CardHeader>
          <CardContent>
            {sent ? (
              <div className="space-y-4 text-center">
                <p className="text-slate-700">If an account exists for <strong>{email}</strong>, a password reset link has been sent. It will expire in 60 minutes.</p>
                <Button onClick={onBack} variant="outline" className="w-full" data-testid="forgot-back-btn">
                  <ArrowLeft className="h-4 w-4 mr-2" /> Back to Login
                </Button>
              </div>
            ) : (
              <form onSubmit={submit} className="space-y-4">
                <div className="space-y-2">
                  <Label htmlFor="fp_email">Email Address</Label>
                  <Input id="fp_email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                    placeholder="you@company.com" data-testid="forgot-email-input" required />
                </div>
                <Button type="submit" disabled={loading} className="w-full" data-testid="forgot-submit-btn">
                  {loading ? <><Loader2 className="h-4 w-4 mr-2 animate-spin" /> Sending...</> : 'Send Reset Link'}
                </Button>
                <Button type="button" variant="ghost" onClick={onBack} className="w-full" data-testid="forgot-back-link">
                  <ArrowLeft className="h-4 w-4 mr-2" /> Back to Login
                </Button>
              </form>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default ForgotPassword;
